import { render, staticRenderFns } from "./liangbiaoCmp.vue?vue&type=template&id=52a88137&"
import script from "./liangbiaoCmp.vue?vue&type=script&lang=ts&"
export * from "./liangbiaoCmp.vue?vue&type=script&lang=ts&"
import style0 from "./liangbiaoCmp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports